import React, { useEffect, useRef, useState } from "react";
import { IoChevronDown } from "react-icons/io5";
import { Modal3 } from "../../../../components/DIsplay/Modal/Modal3";
import TextInput from "../../../../components/form/TextInput";
import Button1 from "../../../../components/form/Button1";
import { enqueueSnackbar } from "notistack";
import AssignVoid from "../../../../components/order/Void/AssignVoid";
import AddVoidRemark from "../../../../components/order/Void/AddVoidRemark";
import voidTicketRequest from "../../../../controllers/booking/postTicketing/void/voidTicketRequest";
import manualVoid from "../../../../controllers/booking/postTicketing/void/manualVoid";
import Modal1 from "../../../../components/DIsplay/Modal/Modal1";
import denyVoidRequest from "../../../../controllers/booking/postTicketing/void/denyVoidRequest";
import VoidNextStepCard from "./VoidNextStepCard";
import VoidReviewModal from "./VoidReviewModal";
import VoidReviewCard from "./VoidReviewCard";
import StaffAsyncActionModal from "../../../../components/order/StaffAsyncActionModal";
import { getStaffApiErrorCopy } from "../../../../components/order/StaffApiErrorModal";
import {
  VOID_ACTION,
  VOID_AIRLINE_DECLINED_REASON,
  getVoidAdminGuidance,
  getVoidAirlineDeclinedActionLabel,
  getVoidAirlineDeclinedCopy,
  getVoidAirlineDeclinedWarningCopy,
  getVoidDeclineActionLabel,
  getVoidManualActionLabel,
  getVoidManualCopy,
  getVoidManualLoadingTitle,
  getVoidManualWarningCopy,
  getVoidOverflowMenuActions,
  getVoidSubmitActionLabel,
  getVoidSubmitCopy,
  getVoidSubmitWarningCopy,
  getVoidRetryAutoConfirmLabel,
  getVoidRetryAutoLoadingTitle,
  isVoidCloseRequestStage,
  isVoidWalletCreditStage,
} from "../../../../data/flight/order/getVoidAdminGuidance";
import VoidMessagesModal from "./VoidMessagesModal";
import SupplierResponseModal from "../../../../components/order/Void/SupplierResponseView";

function VoidConfirmationManageOrder({ data, showBanner = true }) {
  const [manageMenu, setManageMenu] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const [modal, setModal] = useState({
    assign: false,
    decline: false,
    review: false,
    action: false,
    remark: false,
    messages: false,
    supplierResponse: false,
  });
  const [loading, setLoading] = useState({
    void: false,
    manual: false,
    decline: false,
  });
  const [actionResult, setActionResult] = useState({
    phase: "loading",
    kind: "",
    title: "",
    text: "",
  });
  const [rejectReason, setRejectReason] = useState(data?.rejectReason || "");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        manageMenu &&
        !menuRef.current?.contains(event.target) &&
        !buttonRef.current?.contains(event.target)
      ) {
        setManageMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [manageMenu]);

  const og = {
    ...data,
    flightBooking: [data?.flightBooking],
    flightObj: data?.flightBooking,
    type: "Flight",
  };

  const guidance = getVoidAdminGuidance(data);
  const reviewNeeded =
    guidance.stage === "needs_manual_review" ||
    guidance.stage === "send_failed" ||
    guidance.stage === "validation_failed";
  const closingRequest = isVoidCloseRequestStage(data);

  const menuActionMap = {
    [VOID_ACTION.review]: () => setModal({ ...modal, review: true }),
    [VOID_ACTION.assign]: () => setModal({ ...modal, assign: true }),
    [VOID_ACTION.decline]: () => setModal({ ...modal, decline: true }),
    [VOID_ACTION.airlineDeclined]: () => promptAirlineDeclined(),
    [VOID_ACTION.voidTicket]: () => promptSubmitVoid(),
    [VOID_ACTION.manualVoid]: () => promptManualVoid(),
    [VOID_ACTION.remark]: () => setModal({ ...modal, remark: true }),
    [VOID_ACTION.messages]: () => setModal({ ...modal, messages: true }),
    [VOID_ACTION.supplierResponse]: () =>
      setModal({ ...modal, supplierResponse: true }),
  };

  const menuItems = getVoidOverflowMenuActions(data)
    .map((action) => ({
      label: action.label,
      action: menuActionMap[action.key],
    }))
    .filter((item) => item.action);

  function handleAction(key) {
    switch (key) {
      case VOID_ACTION.review:
        setModal({ ...modal, review: true });
        break;
      case VOID_ACTION.assign:
        setModal({ ...modal, assign: true });
        break;
      case VOID_ACTION.decline:
        setModal({ ...modal, decline: true });
        break;
      case VOID_ACTION.airlineDeclined:
        promptAirlineDeclined();
        break;
      case VOID_ACTION.voidTicket:
        promptSubmitVoid();
        break;
      case VOID_ACTION.manualVoid:
        promptManualVoid();
        break;
      case VOID_ACTION.remark:
        setModal({ ...modal, remark: true });
        break;
      case VOID_ACTION.messages:
        setModal({ ...modal, messages: true });
        break;
      case VOID_ACTION.supplierResponse:
        setModal({ ...modal, supplierResponse: true });
        break;
      default:
        break;
    }
  }

  function promptSubmitVoid() {
    setActionResult(getVoidSubmitWarningCopy());
    setModal((prev) => ({ ...prev, action: true }));
  }

  function promptManualVoid() {
    setActionResult(getVoidManualWarningCopy(data));
    setModal((prev) => ({ ...prev, action: true }));
  }

  function promptAirlineDeclined() {
    setActionResult(getVoidAirlineDeclinedWarningCopy());
    setModal((prev) => ({ ...prev, action: true }));
  }

  async function runSubmitVoid() {
    setActionResult({
      phase: "loading",
      kind: "submitting",
      title: "",
      text: "",
    });
    setLoading((prev) => ({ ...prev, void: true }));
    const res = await voidTicketRequest(data?._id).finally(() =>
      setLoading((prev) => ({ ...prev, void: false })),
    );
    setActionResult(getVoidSubmitCopy(res));
  }

  async function runManualVoid() {
    setActionResult({
      phase: "loading",
      kind: "manualing",
      title: "",
      text: "",
    });
    setLoading((prev) => ({ ...prev, manual: true }));
    const res = await manualVoid(data?._id).finally(() =>
      setLoading((prev) => ({ ...prev, manual: false })),
    );
    setActionResult(getVoidManualCopy(res, data));
  }

  async function runAirlineDeclined() {
    setActionResult({
      phase: "loading",
      kind: "airline_declining",
      title: "",
      text: "",
    });
    setLoading((prev) => ({ ...prev, decline: true }));
    const res = await denyVoidRequest(data?._id, {
      rejectReason: VOID_AIRLINE_DECLINED_REASON,
    }).finally(() => setLoading((prev) => ({ ...prev, decline: false })));
    setActionResult(getVoidAirlineDeclinedCopy(res));
  }

  function closeActionModal() {
    setModal((prev) => ({ ...prev, action: false }));
  }

  function showApiError(res, title) {
    setActionResult(getStaffApiErrorCopy(res, title));
    setModal((prev) => ({ ...prev, action: true, decline: false }));
  }

  function getActionModalActions() {
    const kind = actionResult.kind;
    const trySubmit = {
      label: "Try again",
      onClick: () => runSubmitVoid(),
    };
    const tryManual = {
      label: "Try again",
      onClick: () => runManualVoid(),
    };
    const assign = {
      label: "Give to a teammate",
      onClick: () => {
        closeActionModal();
        setModal((prev) => ({ ...prev, assign: true }));
      },
    };
    const seeLatest = {
      label: "See the latest status",
      primary: true,
      onClick: () => window.location.reload(),
    };
    const yesSubmit = {
      label: getVoidRetryAutoConfirmLabel(),
      primary: true,
      onClick: () => runSubmitVoid(),
    };
    const yesManual = {
      label: isVoidWalletCreditStage(data)
        ? "Yes, credit the agent wallet"
        : "Yes, complete and pay the agent",
      danger: true,
      onClick: () => runManualVoid(),
    };
    const yesAirlineDeclined = {
      label: "Yes, airline declined — close this void",
      danger: true,
      onClick: () => runAirlineDeclined(),
    };
    const goBack = {
      label: "Go back",
      onClick: closeActionModal,
    };

    switch (kind) {
      case "submit_warn":
        return [yesSubmit, goBack];
      case "manual_warn":
        return [yesManual, goBack];
      case "airline_decline_warn":
        return [yesAirlineDeclined, goBack];
      case "submitted":
      case "manualed":
      case "airline_declined":
        return [seeLatest];
      case "submit_failed":
        return [{ ...trySubmit, primary: true }];
      case "manual_failed":
        return [
          { ...tryManual, primary: true },
          {
            label: getVoidSubmitActionLabel(),
            onClick: () => promptSubmitVoid(),
          },
          assign,
        ];
      case "airline_decline_failed":
        return [
          {
            label: "Try again",
            primary: true,
            onClick: () => runAirlineDeclined(),
          },
          assign,
        ];
      case "api_error":
        return [{ label: "OK", primary: true, onClick: closeActionModal }];
      default:
        return [goBack];
    }
  }

  async function handleDenyVoid() {
    const reqBody = {
      rejectReason,
    };
    setLoading({ ...loading, decline: true });
    const res = await denyVoidRequest(data?._id, reqBody).finally(() =>
      setLoading({ ...loading, decline: false }),
    );

    if (res.return) {
      enqueueSnackbar(
        closingRequest
          ? "This void request has been closed."
          : "Void request has been declined.",
        {
          variant: "success",
        },
      );
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else showApiError(res);
  }

  return (
    <>
      {showBanner ? (
        <VoidNextStepCard
          data={data}
          loading={{
            [VOID_ACTION.voidTicket]: loading.void,
            [VOID_ACTION.manualVoid]: loading.manual,
            [VOID_ACTION.decline]: loading.decline,
          }}
          onAction={handleAction}
        />
      ) : null}
      {showBanner && reviewNeeded ? <VoidReviewCard data={data} /> : null}

      <VoidReviewModal
        open={modal.review}
        setOpen={(open) => setModal({ ...modal, review: open })}
        data={data}
        onDone={() => window.location.reload()}
        onSubmit={() => {
          setModal((prev) => ({ ...prev, review: false }));
          promptSubmitVoid();
        }}
        onManualVoid={() => {
          setModal((prev) => ({ ...prev, review: false }));
          promptManualVoid();
        }}
      />
      <StaffAsyncActionModal
        open={modal.action}
        setOpen={(open) => setModal((prev) => ({ ...prev, action: open }))}
        title={
          actionResult.kind === "api_error"
            ? actionResult.title
            : [
                "airline_decline_warn",
                "airline_declining",
                "airline_declined",
                "airline_decline_failed",
              ].includes(actionResult.kind)
              ? getVoidAirlineDeclinedActionLabel()
              : ["manual_warn", "manualing", "manualed", "manual_failed"].includes(
                  actionResult.kind,
                )
                ? getVoidManualActionLabel(data)
                : getVoidSubmitActionLabel()
        }
        phase={actionResult.phase}
        loadingTitle={
          actionResult.kind === "airline_declining"
            ? "Recording airline decline"
            : actionResult.kind === "manualing"
              ? getVoidManualLoadingTitle(data)
              : getVoidRetryAutoLoadingTitle()
        }
        loadingText="This can take a few seconds. Stay on this screen. Do not click again."
        resultTitle={actionResult.title}
        resultText={actionResult.text}
        actions={getActionModalActions()}
      />
      <Modal3
        open={modal.assign}
        setOpen={(modalState) => setModal({ ...modal, assign: modalState })}
        title={"Assign Task"}
      >
        <div className="p-4 max-w-[700px]">
          <AssignVoid
            callback={() => window.location.reload()}
            data={og}
            handleVoid={() => promptSubmitVoid()}
          />
        </div>
      </Modal3>
      <Modal3
        open={modal.remark}
        setOpen={(modalState) => setModal({ ...modal, remark: modalState })}
        title={"Add remark"}
      >
        <div className="card p-4 flex flex-col gap-4 md:min-w-[500px]">
          <AddVoidRemark
            data={data}
            close={() => setModal({ ...modal, remark: false })}
            callback={() => window.location.reload()}
          />
        </div>
      </Modal3>
      <VoidMessagesModal
        open={modal.messages}
        setOpen={(open) => setModal({ ...modal, messages: open })}
        data={data}
      />
      <SupplierResponseModal
        open={modal.supplierResponse}
        setOpen={(open) => setModal({ ...modal, supplierResponse: open })}
        data={data?.supplierResponse}
        orderId={data?.orderId}
      />
      <Modal1
        open={modal.decline}
        setOpen={(modalState) => setModal({ ...modal, decline: modalState })}
      >
        <div className="card p-4 flex flex-col  gap-4 min-w-[300px]">
          <h5>
            {closingRequest
              ? "Why are you closing this request?"
              : "Why are you declining this void?"}
          </h5>
          <TextInput
            label=""
            multiline
            rows={5}
            placeholder={"e.g. Void window closed, ticket already used"}
            value={rejectReason || ""}
            onChange={(ev) => setRejectReason(ev.target.value)}
          />
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setModal({ ...modal, decline: false })}
            >
              Cancel
            </Button1>
            <div>
              <Button1
                onClick={() => handleDenyVoid()}
                loading={loading.decline}
              >
                {getVoidDeclineActionLabel(data)}
              </Button1>
            </div>
          </div>
        </div>
      </Modal1>

      {menuItems?.length ? (
        <div className="relative w-full lg:w-fit ml-auto mt-2">
          <button
            ref={buttonRef}
            onClick={() => setManageMenu((prev) => !prev)}
            className="border border-gray-300 h-12 rounded-md bg-gray-100 hover:bg-gray-200 transition-all w-full px-2 lg:px-4 flex items-center justify-center gap-2 text-sm font-semibold"
          >
            <span>More actions</span>
            <IoChevronDown
              className={`text-base transition-transform mt-[2px] ${
                manageMenu ? "rotate-180" : ""
              }`}
            />
          </button>

          {manageMenu && (
            <div
              ref={menuRef}
              className="absolute right-0 mt-2 w-56 rounded-md border border-gray-200 bg-white shadow-lg overflow-hidden z-20"
            >
              <div className="px-3 py-2 text-xs text-gray-500 border-b border-gray-100">
                Current: {guidance.statusLabel}
              </div>
              {menuItems.map((itm, idx) => (
                <button
                  key={idx}
                  onClick={() => {
                    setManageMenu(false);
                    itm.action?.();
                  }}
                  className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50"
                >
                  {itm.label}
                </button>
              ))}
            </div>
          )}
        </div>
      ) : null}
    </>
  );
}

export default VoidConfirmationManageOrder;
